<h2 mat-dialog-title>Aggiungi Isin {{ data.isin }}</h2>

<mat-dialog-content>
  <form #form="ngForm">
    <mat-form-field>
      <mat-label>Scegli la watchlist</mat-label>
      <mat-select name="watchlist" [(ngModel)]="watchlist" [disabled]="loading">
        <mat-option *ngFor="let option of data.watchlists" [value]="option">{{option.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()" [disabled]="loading">Annulla</button>
  <button mat-button *ngIf="!loading" (click)="onYesClick()" [disabled]="!watchlist">Aggiungi</button>
  <div *ngIf="loading" class="spinner-container">
    <mat-spinner diameter="20"></mat-spinner>
  </div>
</mat-dialog-actions>
